/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrgAdminSearchRequestModel } from '../../models/org-admin-search-request-model';

export interface OrgAdminDailySummaryReportExcelPost$Params {
      body?: OrgAdminSearchRequestModel
}

export function orgAdminDailySummaryReportExcelPost(http: HttpClient, rootUrl: string, params?: OrgAdminDailySummaryReportExcelPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, orgAdminDailySummaryReportExcelPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as WearablesStrictHttpResponse<void>;
    })
  );
}

orgAdminDailySummaryReportExcelPost.PATH = '/OrgAdmin/DailySummaryReportExcel';
